import { Image } from '@fluentui/react/lib/Image';
import { Link } from '@fluentui/react/lib/Link';
import { observer } from 'mobx-react-lite';
import { logUsage } from 'owa-analytics';
import { getOwaResourceUrl } from 'owa-resource-url';
import { beginLightning } from 'owa-lightning-core-v2';
import { lighted, LightningId, shouldShowLightningItem } from 'owa-lightning-v2';
import loc from 'owa-localize';
import * as React from 'react';
import {
    spotlightFreTitle,
    spotlightFreDescription,
    spotlightCtaButtonLabel,
} from './SpotlightFre.locstring.json';

const styles = require('./SpotlightFre.scss');
const SPOTLIGHT_FRE_SVG = require('./SpotlightFre.svg');

export default observer(function SpotlightFre() {
    React.useEffect(() => {
        // Initialize Lightning for this feature when component mounts.
        beginLightning(LightningId.SpotlightFre, triggerLightup);
    }, []);

    // Don't render FRE if user has acknowledged it already.
    if (!shouldShowLightningItem(LightningId.SpotlightFre)) {
        return null;
    }

    /**
     * Callback for when user clicks the "Got It" button in the FRE which means
     * we shouldn't show it again to this user in the future.
     */
    const onGotItClicked = () => {
        lighted(LightningId.SpotlightFre);
        logUsage('Spotlight_TeachingMomentDismissed');
    };

    return (
        <div className={styles.spotlightFreContainer}>
            <Image
                title={loc(spotlightFreTitle)}
                className={styles.spotlightFreImage}
                shouldFadeIn={false}
                src={getOwaResourceUrl(SPOTLIGHT_FRE_SVG)}
            />
            <span className={styles.spotlightFreTitle}>{loc(spotlightFreTitle)}</span>
            <span className={styles.spotlightFreDescription}>{loc(spotlightFreDescription)}</span>
            <Link className={styles.spotlightCta} onClick={onGotItClicked}>
                {loc(spotlightCtaButtonLabel)}
            </Link>
        </div>
    );
});

const triggerLightup = (lightup: () => void): void => {
    lightup();
};
